module.exports = __webpack_public_path__ + "img/25.38b4a90d.jpg";